// The version every /data/* URL must carry.
//
// /data/* is served "immutable, cache for a year" (staticwebapp.config.json) and the files are
// replaced in place on deploy, so a URL without a version pins a browser to the first copy it
// ever fetched. The loader always versioned its URLs; the prediction model did not, and Kevin's
// browser kept the first model for days while every retrain went unseen (2026-10-19: his page
// predicted no UP distances or inlet positions, a fresh browser predicted them all). Every
// fetch of a /data/* file goes through versioned().
//
// __CPQ_DATA_VERSION__ is the content hash of public/data, injected at build time by
// vite.config.ts. Declared defensively: the scripts/ suites import this under plain Node, where
// the define does not exist, and nothing here may crash simply by being imported.
declare const __CPQ_DATA_VERSION__: string;
export const dataVersion = (): string => {
  try {
    return typeof __CPQ_DATA_VERSION__ === "string" ? __CPQ_DATA_VERSION__ : "dev";
  } catch {
    return "dev";
  }
};
/** Append the data version, preserving any query the caller already put on the path. */
export const versioned = (url: string): string => `${url}${url.includes("?") ? "&" : "?"}v=${dataVersion()}`;
